import Vue from "vue";
import "@main/packages/TheModal/Plugin";

const ModalStatusOrder = () =>
    import(
        /* webpackChunkName: "M_S_O" */ "@main/packages/TheModal/components/ModalStatusOrder"
    );
const ModalSelectCity = () =>
    import(
        /* webpackChunkName: "M_S_C" */ "@main/packages/TheModal/components/ModalSelectCity"
    );
const ModalPreOrder = () =>
    import(/* webpackChunkName: "M_P_O" */ "@main/packages/TheModal/components/ModalPreOrder");
const ModalCallback = () =>
    import(/* webpackChunkName: "M_C" */ "@main/packages/TheModal/components/ModalCallback");
const ModalOneClick = () =>
    import(/* webpackChunkName: "M_O_C" */ "@main/packages/TheModal/components/ModalOneClick");

const ModalVideo = () =>
    import(/* webpackChunkName: "M_V" */ "@main/packages/TheModal/components/ModalVideo");
const ModalProfileAuth = () =>
    import(
        /* webpackChunkName: "M_P_A" */ "@main/packages/TheModal/components/ModalProfileAuth"
    );

const ModalFeedbackFooter = () =>
    import(
        /* webpackChunkName: "M_F_F" */ "@main/packages/TheModal/components/ModalFeedbackFooter"
    );

const ModalCartError = () =>
    import(
        /* webpackChunkName: "M_C_E" */ "@main/packages/TheModal/components/ModalCartError"
    );

// const ModalNewYear = () =>
//     import(
//         /* webpackChunkName: "M_N_Y" */ "@main/packages/TheModal/components/ModalScheduleNewYear"
//     );

Vue.component("modal-select-city", ModalSelectCity);
Vue.component("modal-pre-order", ModalPreOrder);
Vue.component("modal-callback", ModalCallback);
Vue.component("modal-one-click", ModalOneClick);
Vue.component("modal-status-order", ModalStatusOrder);
Vue.component("modal-video", ModalVideo);
Vue.component("modal-profile-auth", ModalProfileAuth);
Vue.component("modal-feedback-footer", ModalFeedbackFooter);
Vue.component("modal-cart-error", ModalCartError);
// Vue.component("modal-schedule-new-year", ModalNewYear);
